import { useEffect } from 'react';
import { useWorkspaceStore } from '@/store/workspace.store';
import { cssDeMarca } from '@/lib/marca';

/**
 * Dentro del negocio de un cliente, la piel toma SU color (punto 11 del rebranding): una hoja
 * que pisa las fichas del acento de `index.css`, en claro y en oscuro. Sin color guardado (o
 * fuera del panel: login, cambio de negocio) la hoja no existe y queda el magenta de Silva Notion.
 */
export function usePielDelNegocio(): void {
  const color = useWorkspaceStore((s) => s.items.find((w) => w.id === s.activeId)?.colorMarca ?? null);
  useEffect(() => {
    const css = color ? cssDeMarca(color) : '';
    if (!css) return;
    const hoja = document.createElement('style');
    hoja.id = 'piel-del-negocio';
    hoja.textContent = css;
    document.head.appendChild(hoja);
    return () => hoja.remove();
  }, [color]);
}
